var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUfo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 30,
    viewBox: "0 0 54 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.5063 11.4133C36.7597 4.98667 32.333 0 26.9997 0C21.6663 0 17.2397 4.98667 16.493 11.4133C6.99968 12.8533 0.333008 16.16 0.333008 20C0.333008 25.1467 12.333 29.3333 26.9997 29.3333C41.6663 29.3333 53.6663 25.1467 53.6663 20C53.6663 16.16 46.9997 12.8533 37.5063 11.4133Z",
    fill: "#ABB5BE"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUfo);
export default __webpack_public_path__ + "static/media/UFO.634a1882.svg";
export { ForwardRef as ReactComponent };